export class AccessToken {
  private _clients: string[] | null = null;
  private _userRole: string | null = null;

  constructor(public readonly raw: string) {
    const claims = AccessToken.parseClaims(raw);
    this._clients = AccessToken.readClients(claims);
    this._userRole = AccessToken.readUserRole(claims);
  }

  get clients(): string[] | null {
    return this._clients;
  }

  /**
   * The 'type' claim, issued by the Identity provider's ProfileService straight
   * from HUser.UserRole. The API's global authorization filter accepts exactly
   * four values: 'ClientAdmin', 'MasterClientAdmin', and the two '...-View Only'
   * variants.
   */
  get userRole(): string | null {
    return this._userRole;
  }

  private static parseClaims(token: string): Record<string, unknown> | null {
    if (!token) return null;
    try {
      const payload = token.split('.')[1];
      if (!payload) return null;
      const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
      return JSON.parse(decoded) as Record<string, unknown>;
    } catch {
      return null;
    }
  }

  private static readUserRole(claims: Record<string, unknown> | null): string | null {
    const raw = claims?.['type'];
    if (typeof raw === 'string') {
      return raw.trim() || null;
    }
    // Defensive: a token could carry the claim more than once.
    if (Array.isArray(raw) && raw.length > 0) {
      return String(raw[0]).trim() || null;
    }
    return null;
  }

  private static readClients(claims: Record<string, unknown> | null): string[] | null {
    const rawClients = claims?.['client-id'];
    if (!rawClients) return null;
    if (typeof rawClients === 'string') {
      try {
        const parsed = JSON.parse(rawClients);
        if (Array.isArray(parsed)) return parsed.map(String);
        return [String(rawClients)];
      } catch {
        return [rawClients as string];
      }
    }
    if (Array.isArray(rawClients)) return rawClients.map(String);
    return [String(rawClients)];
  }
}
